'use client';

import { useUserSync } from '@shared/lib/hooks/useUserSync';
import { useActorSync } from '@shared/lib/hooks/useActorSync';

/**
 * User Sync Provider
 * 
 * Periodically syncs user state with backend
 * - Syncs user verification status
 * - Syncs activeActor if missing
 */
export function UserSyncProvider({ children }: { children: React.ReactNode }) {
  useUserSync();
  useActorSync();
  
  return <>{children}</>;
}
